import _ from "lodash";
export function getConfigV2(stageEnvs, defaultEnv, myEnv) {
    if (!process.env.STAGE_ENV) {
        process.env.STAGE_ENV = "local";
    }
    const stage = process.env.STAGE_ENV;
    const stageEnv = stageEnvs[stage];
    if (!stageEnv) {
        throw Error(`Not found stage configurations for ${stage}`);
    }
    // Don't use my if test env
    if (stage == "test") {
        myEnv = {};
    }
    return _.merge({}, defaultEnv, stageEnv, myEnv);
}
export default getConfigV2;
